import {CATEGORY} from 'constants/actions';
import type {ActiveSortType, ActionType} from 'constants/flow/flowTypes';

import {getSortFromUrl} from 'libs/sort/sort';

export const initialState = getSortFromUrl();

/**
 * Get active sort
 *
 * @param {ActiveSortType} state  - Current state
 * @param {ActionType<ActiveSortType>} action - Received action
 *
 * @returns {ActiveSortType} - active sort
 */
export default function activeSort(
    state: ActiveSortType = initialState,
    action: ActionType<ActiveSortType>,
): ActiveSortType {
    switch (action.type) {
        case CATEGORY.GET_ACTIVE_SORT:
            return action.sort;
        default:
            return state;
    }
}
